import './App.css';
import Navbar from './components/Navbar/Navbar';
import Home from './components/Home/Home';
import About from './components/About/About';
import Gallery from './components/Gallery/Gallery';
import Rooms from './components/Rooms/Rooms';
import Footer from './components/Footer/Footer';
import { BrowserRouter as Router, Route, Routes} from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

function App() {
  AOS.init();
  return (
    <Router>
    <div className="App">
      <Navbar />
      <div className='content'>
        <Routes>
          <Route path='' exact element={<Home />} />
          <Route path='/about' element={<About />} />
          <Route path='/gallery' element={<Gallery />} />
          <Route path='/rooms' element={<Rooms />} />
        </Routes>
      </div>
      <Footer />
    </div>
    </Router>
  );
}

export default App;
